import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { INSTALLMENT_OPTIONS } from "@/constants/payroll-installments";
import { formatToBRL } from "@/utils/formatToMoney";
import { divideInstallments } from "@/utils/payroll-installments";
import { JSX } from "react";

import { DECISION_LABELS } from "../../utils/messages";

interface InstallmentsFieldProps {
  id: string;
  amount: number | string | null | undefined;
  value: number;
  disabled: boolean;
  showHint: boolean;
  onChange: (value: number) => void;
}

export function InstallmentsField({
  id,
  amount,
  value,
  disabled,
  showHint,
  onChange,
}: InstallmentsFieldProps): JSX.Element {
  const preview: number = Math.abs(
    divideInstallments(Number(amount ?? 0), value)[0],
  );

  return (
    <div className="w-full space-y-1">
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {DECISION_LABELS.INSTALLMENTS_LABEL}
      </label>
      <Select
        value={`${value}`}
        onValueChange={(selected: string): void => onChange(Number(selected))}
        disabled={disabled}
      >
        <SelectTrigger
          id={id}
          data-testid={id}
          className="w-full"
          aria-label={DECISION_LABELS.INSTALLMENTS_LABEL}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {INSTALLMENT_OPTIONS.map(
            (option: number): JSX.Element => (
              <SelectItem key={option} value={`${option}`}>
                {`${option}x`}
              </SelectItem>
            ),
          )}
        </SelectContent>
      </Select>
      <p className="text-xs text-gray-600" data-testid={`${id}-preview`}>
        {`${DECISION_LABELS.INSTALLMENTS_PREVIEW} ${formatToBRL(preview)}.`}
      </p>
      {showHint ? (
        <p className="text-xs text-gray-500">
          {DECISION_LABELS.INSTALLMENTS_HINT}
        </p>
      ) : null}
    </div>
  );
}
